/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryRoleMapping,
  DirectoryRoleMapping$inboundSchema,
} from "./directoryrolemapping.js";
import {
  DirectoryRoleSetupSideEffect,
  DirectoryRoleSetupSideEffect$inboundSchema,
} from "./directoryrolesetupsideeffect.js";
import { Role, Role$inboundSchema } from "./role.js";

/**
 * The item's state after the decision.
 */
export const ResolveDirectoryReviewItemResultState = {
  Approved: "approved",
  Dismissed: "dismissed",
} as const;
/**
 * The item's state after the decision.
 */
export type ResolveDirectoryReviewItemResultState = OpenEnum<
  typeof ResolveDirectoryReviewItemResultState
>;

export type ResolveDirectoryReviewItemResult = {
  /**
   * Roles the approval created.
   */
  createdRoles: Array<Role>;
  /**
   * The mappings an approval of a new source wrote. Empty for every other decision.
   */
  mappings: Array<DirectoryRoleMapping>;
  /**
   * Work requested after commit.
   */
  sideEffects: Array<DirectoryRoleSetupSideEffect>;
  /**
   * The item's state after the decision.
   */
  state: ResolveDirectoryReviewItemResultState;
};

/** @internal */
export const ResolveDirectoryReviewItemResultState$inboundSchema: z.ZodMiniType<
  ResolveDirectoryReviewItemResultState,
  unknown
> = openEnums.inboundSchema(ResolveDirectoryReviewItemResultState);

/** @internal */
export const ResolveDirectoryReviewItemResult$inboundSchema: z.ZodMiniType<
  ResolveDirectoryReviewItemResult,
  unknown
> = z.pipe(
  z.object({
    created_roles: z.array(Role$inboundSchema),
    mappings: z.array(DirectoryRoleMapping$inboundSchema),
    side_effects: z.array(DirectoryRoleSetupSideEffect$inboundSchema),
    state: ResolveDirectoryReviewItemResultState$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_roles": "createdRoles",
      "side_effects": "sideEffects",
    });
  }),
);

export function resolveDirectoryReviewItemResultFromJSON(
  jsonString: string,
): SafeParseResult<ResolveDirectoryReviewItemResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResolveDirectoryReviewItemResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResolveDirectoryReviewItemResult' from JSON`,
  );
}
